import React from 'react'
import { Choose } from 'react-extras'

import { Breadcrumb, Icon } from 'antd'

import { breadcrumb } from '../../routes/breadcrumbs'
import { getMessage } from '../../util/IntlMessages'

const CustomBreadcrumb = function (props) {
  function renderPath() {
    const path = window.location.pathname.split('/').filter((item) => item)
    const paths = breadcrumb(path, props.match, props.rootIsList)

    return paths.map((item, index) => (
      <Breadcrumb.Item key={index} onClick={() => props.history.push(item.breadcrumbPath)}>
        <Choose>
          <Choose.When condition={item.breadcrumbPath === window.location.pathname}>
            {getMessage(item.label)}
          </Choose.When>
          <Choose.Otherwise>
            <a>
              <span>{getMessage(item.label)}</span>
            </a>
          </Choose.Otherwise>
        </Choose>
      </Breadcrumb.Item>
    ))
  }

  return (
    <Breadcrumb>
      <Breadcrumb.Item onClick={() => props.history.push('/')}>
        <Icon
          type="home"
          theme="filled"
          style={{ fontSize: '16px', color: '#263447' }}
          onClick={() => props.history.push('/')}
        />
      </Breadcrumb.Item>
      {renderPath()}
    </Breadcrumb>
  )
}

export { CustomBreadcrumb }
